module.exports = __webpack_public_path__ + "static/media/phone.7143db4e.svg";